import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PERMISSION_TALENTS_READ
  } from '../../../constants'
  import {checkPermission} from '../../common/functions/permissions'
import Table from '../../../tables/reactable/DefaultTable'

class CriteriaResult extends Component {
  constructor() {
    super()
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: false
    }
    this.columns = [
      'AvatarImage',
      'FullName',
      'ProdubNumber',
      'ActiveProfiles'
    ]
    this.columnNames = [
      '',
      'Full name',
      'Number',
      'Active profiles'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  render() {
    // let items = this.props.skillVendorsByCriteria.map(item => {
    let items = this.props.result.map(item => {
      return Object.assign({}, item, {
        AvatarImage: item.AvatarImageUrl ? (<img src={item.AvatarImageUrl} style={{width: '50px'}} className="rounded-circle" alt="" />) : (null),
        FullName: checkPermission(PERMISSION_TALENTS_READ)
          ? (<a href={'/talents/' + item.Id + '/overview'}>{item.FullName}</a>)
          : (<span>{item.FullName}</span>)
      })
    });

    return (
      <div>
        <Table
        items={items}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        searchVisible={false}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
        openBtnVisible={this.state.openBtnVisible}
        sortable={[
          {
            column: 'FullName',
            sortFunction: function(a, b) {
              return a.props.children.localeCompare(b.props.children);
            }
          },
          'ProdubNumber',
          'ActiveProfiles'
        ]}
        defaultSort={{column: 'FullName', direction: 'asc'}}
        selectPerPageCss={"-4rem"}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorsByCriteria: state.vacancyPage.skillVendorsByCriteria
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(CriteriaResult)
